export default __webpack_public_path__ + "aac8a9046e356810187a05731361d054.png";